import {types} from 'mobx-state-tree';
import NormalizedMessageModel from './shared/normalizedMessageModel';

const ChannelMessagePreviewModel = types.compose(
  NormalizedMessageModel,
  types.model({
    createdAtInMs: types.string
  })
);

export type ChannelMessagePreviewType = typeof ChannelMessagePreviewModel.Type;

export default ChannelMessagePreviewModel;



// WEBPACK FOOTER //
// ./src/models/chatChannelModel/message/channelMessagePreviewModel.ts